import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import PackageOptionsList from './PackageOptionsList';
import OptionCard, {
  OptionCardPrimarySection,
} from '../../../components/cards/optionCard/OptionCard';
import { SimpleOptionInfo } from '../../options/SimpleOptionCard';
import PackagePricing from '../../../components/packages/PackagePricing';
import { combineClassNames } from 'core/css';

const PackageCard = ({
  option,
  onChange,
  onDetails,
  analyticsKey,
  disabled,
  isUpdating,
  hideInfoIcon,
  selectingOption,
  checked,
  showAllOptions,
  stacked,
}) => {
  const {
    code,
    largeImageUrl,
    packages,
    selected,
    description,
    optionMarker,
  } = option;

  return (
    <OptionCard
      option={option}
      type="package"
      role="checkbox"
      image={largeImageUrl}
      selected={selected || checked}
      aria-checked={selected || checked}
      disabled={disabled}
      onChange={() => {
        onChange(option);
      }}
      onKeyDown={() => {
        onChange(option);
      }}
      analyticsKey={analyticsKey}
      analyticsKey2={description}
      optionMarker={optionMarker}
      isUpdating={isUpdating}
      isUpdatingOption={isUpdating && get(selectingOption, 'code') === code}
      stacked={stacked}>
      <OptionCardPrimarySection>
        <div className="package-option-container">
          <div
            className="package-option__label"
            dangerouslySetInnerHTML={{ __html: description }}></div>
          <PackageOptionsList
            id={code}
            options={packages}
            analyticsKey={analyticsKey}
            analyticsKey2={description}
            showAllOptions={showAllOptions}
          />

          <div
            className={combineClassNames(
              'package-option__price-container',
              hideInfoIcon ? 'package-option__price-container--no-info' : ''
            )}>
            {!hideInfoIcon && (
              <SimpleOptionInfo
                option={option}
                onDetails={onDetails}
                analyticsKey={analyticsKey}
                analyticsKey2={description}
              />
            )}
            <PackagePricing option={option} className={analyticsKey} />
          </div>
        </div>
      </OptionCardPrimarySection>
    </OptionCard>
  );
};

PackageCard.defaultProps = {
  checked: false,
};

PackageCard.propTypes = {
  hideInfoIcon: PropTypes.bool,
  checked: PropTypes.bool,
};

export default PackageCard;
